import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import InfiniteLoader from 'react-window-infinite-loader'
import AutoSizer from 'react-virtualized-auto-sizer'

const VirtualList = props => {
	const loaderRef = useRef()
	const {
		width,
		height,
		itemRenderer,
		itemCount,
		itemSize,
		style,
		className,
		noItemsRenderer,
		getScrollStartIndex,
		loading,
		error,
		hasNextPage,
		hasPreviousPage,
		loadNextPage,
		loadPreviousPage,
		dataLoadOffset = 50,
		startFromIndex = 0,
		disableAutoSizer,
		...rest } = props
	if(itemCount === 0 && noItemsRenderer) {
		return noItemsRenderer()
	}

	const renderList = ({ width: autoWidth, height: autoHeight }) => (
		<InfiniteLoader
			ref={loaderRef}
			isItemLoaded={isItemLoaded}
			loadMoreItems={loadMoreItems}
			itemCount={itemCount}
		>
			{({ onItemsRendered, ref }) => {
				const listHeight = height || autoHeight
				const listWidth = width || autoWidth
				const totalItemHeight = itemSize * itemCount
				const initialScrollOffset = listHeight > totalItemHeight ? 0 : startFromIndex * itemSize
				return(
					<List
						{...rest}
						ref={ref}
						style={style}
						className={className}
						onItemsRendered={onItemsRendered}
						initialScrollOffset={initialScrollOffset}
						height={listHeight}
						width={listWidth}
						itemSize={itemSize}
						itemCount={itemCount}
					>
						{itemRenderer}
					</List>
				)
			}}
		</InfiniteLoader>
	)

	const isItemLoaded = index => {
		return (!hasNextPage || index < itemCount - dataLoadOffset) &&
		(!hasPreviousPage || index > dataLoadOffset)
	}

	const loadMoreItems = (startIndex, stopIndex) => {
		const isLoadingNextPage = stopIndex > itemCount - dataLoadOffset
		const isLoadingPreviousPage = startIndex < dataLoadOffset

		if(isLoadingNextPage && loadNextPage && !loading && !error) {
			return loadNextPage()
		}
		if(isLoadingPreviousPage && loadPreviousPage && !loading && !error) {
			loadPreviousPage().then((res) => {
				if(loaderRef.current) {
					const listRef = loaderRef.current._listRef
					const newRecordsNumber = loaderRef.current.props.itemCount - itemCount
					listRef.scrollTo(listRef.state.scrollOffset + newRecordsNumber * itemSize)
				}
			})
		}
	}

	if(disableAutoSizer) {
		return renderList({})
	}

	return(
		<AutoSizer disableHeight={!!height} disableWidth={!!width}>
			{renderList}
		</AutoSizer>
	)
}

export default VirtualList
